<template>
  <div class="v-checkbox"
       :class="{
      'v-checkbox--is-dirty': isDirty,
      'v-checkbox--is-disabled': disabled,
      'v-checkbox--has-label': Object.keys(options).length || this.$slots.default
    }"
       data-vv-value-path="model"
       :data-vv-as="label">
    <label v-if="selectAllCheckboxes" class="v-checkbox__item v-checkbox__item--select-all">
      <input type="checkbox"
             name="tags[]"
             @change="selectAll" v-model="allSelected">

      <div class="v-checkbox__indicator"></div>

      <span>Select all</span>
    </label>
    <div v-else-if="customLabel && customLabel !=''" style="width: 100%;">
      <label class="v-form__label" style="margin-right: 10px;">
        {{customLabel}}
      </label>
    </div>
    <template v-if="Object.keys(options).length">
      <label class="v-checkbox__item"
             v-for="key in orderedOptionKeys"
             :key="key">
        <input v-if="isSingleCheckbox"
               type="checkbox"
               :value="key"
               v-model="model"
               :true-value="1"
               :false-value="0"
               :name="name"
               :disabled="disabled"
               @change="stateChange(model)">

        <input v-else
               type="checkbox"
               :value="key"
               v-model="model"
               :name="name"
               :id="id || `${name}-${key}`"
               :data-id="`${customName}-${key}`"
               :disabled="disabled"
               true-value="yes"
               false-value="no"
               @change="stateChange(model); select()">

        <div class="v-checkbox__indicator"></div>

        <template v-if="options[key]">
          <span v-html="options[key]"></span>
        </template>
      </label>
    </template>

    <label class="v-checkbox__item" v-else>
      <input type="checkbox"
             v-model="model"
             :name="name"
             :disabled="disabled"
             @change="stateChange(model)">

      <div class="v-checkbox__indicator"></div>

      <template>
        <slot></slot>
      </template>
    </label>

    <input type="hidden"
           :name="`hidden_` + name"
           v-model="model"
           v-validate="rules">

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'

  export default {
    computed: {
      isDirty() {
        return !!this.model
      },
      orderedOptionKeys() {
        return this.optionOrder.length
          ? this.optionOrder
          : Object.keys(this.options)
      }
    },
    data() {
      return {
        model: this.isSingleCheckbox ? (this.value && this.value != 0 ? 1 : 0) : (this.hasMultipleValues ? this.value : (this.value ? [this.value] : this.values)),
        allSelected: false
      }
    },
    mixins: [field],
    methods: {
      stateChange(model) {
        this.$emit('changed', model);
      },
      selectAll: function () {
        this.model = [];

        if (this.allSelected) {
          let option;

          this.orderedOptionKeys.forEach(key => {
            this.model.push(key);
          });
        }
      },
      select: function () {
        this.allSelected = false;
      }
    },
    created() {
      this.$root.$on('emptyCheckboxModel', () => {
        this.model = [];
      });

      if (this.selectAllCheckboxes && this.model.length == Object.values(this.options).length) {
        this.allSelected = true;
      }
    },
    props: {
      options: {
        default: () => { return {} },
        type: [Object, Array]
      },
      values: {
        default: () => { return [] },
        type: Array
      },
      value: {
        default: '',
        type: [Number, String, Array, Boolean]
      },
      isSingleCheckbox: {
        default: false,
        type: Boolean
      },
      hasMultipleValues: {
        default: false,
        type: Boolean
      },
      selectAllCheckboxes: {
        default: false,
        type: Boolean
      },
      id: {
        default: '',
        type: String
      },
      customName: {
        default: '',
        type: String
      },
      customLabel: {
        default: '',
        type: String
      },
      optionOrder: {
        default: () => [],
        type: Array
      }
    },
    watch: {
      value(value) {
        if (value === "0") {
          this.model = false
        }else{
          this.model = this.value;
        }
      },
      values() {
        this.model = this.values;
      }
    }
  }
</script>
